import React from "react";
import "./Footer.sass";
import {formatAmount} from "../../utils";
import {ReactComponent as Back} from "../../svg/Back.svg";
const {Translations} = window;

const Footer = ({onSubmit, count , sum, onBack}) => {
    return (
        <div className="Footer">
            <div className="Footer-col">
                <div className="Footer-col-title">
                    {Translations.piecesTitle}:
                </div>
                {`${count} ${Translations.pieces}`}
            </div>
            <div className="Footer-col">
                <div className="Footer-col-title">
                    {Translations.currencyTitle}:
                </div>
                {formatAmount(sum)}
            </div>
            <div className={`add-to-basket-btn product-about-btn default-btn ${count === 0 ? "disabled" : ""}`} onClick={onSubmit}>Купить</div>
            <div className={`Footer-back`} onClick={onBack}><Back/></div>
        </div>
    )
}

export default Footer
